import { Star } from './RectangleFaces';
import starlink from '../assets/starlink-x4.webp';

const Starlink = () => {
  return (
    <div
      className="absolute bottom-8 left-20 z-30 transform-gpu transition-all duration-[300ms] ease-in-out will-change-transform group-hover:-translate-y-[100px]"
      style={{ backfaceVisibility: 'hidden' }}
    >
      <img
        src={starlink}
        alt="Starlink device"
        className="will-change-transform"
        width="51px"
        height="59px"
        style={{ backfaceVisibility: 'hidden' }}
      />
      <div className="absolute -left-0.5 bottom-[22px] rotate-[-30deg]">
        <Star />
      </div>
      <div className="absolute -right-2 bottom-[34px] rotate-[30deg]">
        <Star />
      </div>
      <div className="absolute -bottom-1 left-6 rotate-[14deg]">
        <Star />
      </div>
    </div>
  );
};

export default Starlink;
